import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LoadingScreen from "../LoadingScreen";

const RouteLoader = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    // No delay, immediate loading
    setLoading(false);
  }, [location.pathname]);

  return loading ? <LoadingScreen /> : children;
};

export default RouteLoader;
